<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Helpers
	import { is_gen_2, real_id } from 'src/helpers/interface_helpers';
	import { setURLParams } from 'src/helpers/actions/local/core/local_action_parse_url_helpers';
	import { getDeviceIP } from 'src/helpers/actions/webhooks/core/webhook_devices_helpers';
	import { getURLWebhookParams } from 'src/helpers/actions/webhooks/core/webhook_parse_url_helpers';
	import { setURLParamsG1 } from 'src/helpers/actions/webhooks/core/webhook_helpers_gen1';
	//Components
	import LocalActionsModal from 'src/components/DevicesSettings/LocalActions/LocalActionsModal.svelte';
	import DevicesList from './DeviceActions/DevicesList.svelte';
	import URLActions from './URLActions.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { ActionJob, DeviceAction } from 'src/types/requests/schedules/schedules_g2';
	import type { WebhookURLError } from 'src/helpers/actions/webhooks/core/webhook_url_action_helpers';

	export let urls: string[], error: WebhookURLError, tokens: string[], device: Device;

	let currentUrlIndex = 0;
	let selectedDevice: Device = null;
	let localAction: ActionJob = null;
	let deviceAction: DeviceAction = {
		action: null,
		device: null,
	};
	let allDevices: Device[] = null;
	let isEditDevice = false;

	const deviceCopy = { ...device };

	const onClickLocalInputField = (e: CustomEvent): void => {
		currentUrlIndex = e.detail.urlIndex;
		localAction = e.detail.localAction;
	};

	const saveAction = (e: CustomEvent) => {
		if (urls.length == 1 && urls[0] == '') {
			currentUrlIndex = 0;
		}
		urls[currentUrlIndex] = setURLParams(e.detail);
		urls = urls;
		localAction = null;
	};

	const onEditDeviceLocalAction = (e: CustomEvent): void => {
		currentUrlIndex = e.detail.urlIndex;
		deviceAction = e.detail.deviceAction;
		isEditDevice = true;
	};

	const saveDeviceLocalAction = (e: CustomEvent) => {
		const ip =
				real_id(deviceCopy.id) == real_id(deviceAction.device.id)
					? '127.0.0.1'
					: getDeviceIP(deviceAction.device),
			device = deviceAction.device,
			action: ActionJob = e.detail;
		urls[currentUrlIndex] = is_gen_2(device)
			? setURLParams(action, ip)
					.replace('a2=1&', '')
					.replace(/\?a2=1$/, '')
			: setURLParamsG1(action, ip);
		deviceAction = {
			action: null,
			device: null,
		};
		allDevices = null;
		selectedDevice = null;
	};

	const closeDeviceLocalAction = () => {
		selectedDevice = null;
		deviceAction = {
			action: null,
			device: null,
		};
	};

	const onSelectDevice = (e: CustomEvent) => {
		const url = e.detail.url;
		currentUrlIndex = urls.length == 1 && urls[0] == '' ? 0 : urls.length;
		selectedDevice = e.detail.device;
		deviceAction = {
			action: getURLWebhookParams(url, selectedDevice),
			device: selectedDevice,
		};
	};
</script>

<URLActions
	bind:urls
	bind:allDevices
	{error}
	{tokens}
	device={deviceCopy}
	on:action={onClickLocalInputField}
	on:edit={onEditDeviceLocalAction}
/>

{#if localAction != null}
	<LocalActionsModal
		{device}
		bind:action={localAction}
		on:save={saveAction}
		on:close={() => {
			localAction = null;
		}}
	/>
{:else if deviceAction?.action != null && allDevices == null}
	<LocalActionsModal
		modalTitle={isEditDevice &&
			$format('Edit local action', {
				default: 'Edit local action',
			})}
		device={deviceAction.device}
		bind:action={deviceAction.action}
		on:save={saveDeviceLocalAction}
		on:close={closeDeviceLocalAction}
	/>
{:else if allDevices != null}
	<DevicesList
		{allDevices}
		device={deviceAction.device}
		bind:action={deviceAction.action}
		on:save={saveDeviceLocalAction}
		on:onSelect={onSelectDevice}
		on:close={() => {
			allDevices = null;
			closeDeviceLocalAction();
		}}
	/>
{/if}
